export const isArray = (val: unknown): val is unknown[] => Array.isArray(val)

export const isBoolean = (val: unknown): val is boolean =>
  typeof val === 'boolean'

// truthy is every value except "", null, undefined, 0, or false.
export const isTruthy = (...values: unknown[]) => values.some(val => !!val)

// tslint:disable-next-line:ban-types
export const isFunction = (val: unknown): val is Function =>
  typeof val === 'function'

export const isNull = (val: unknown): val is null => val === null

export const isNumber = (val: unknown): val is number => typeof val === 'number'

export const isObject = (val: unknown): val is object => val === Object(val)

export const isString = (val: unknown): val is string => typeof val === 'string'

export const isError = (val: unknown): val is Error =>
  isObject(val) && val.constructor === Error

export const isValidJSON = (val: string) => {
  try {
    JSON.parse(val)

    return true
  } catch (e) {
    return false
  }
}

export const arrayIsEmpty = (arr: unknown) => isArray(arr) && arr.length === 0

export const objectIsEmpty = (obj: unknown) =>
  isObject(obj) && Object.keys(obj).length === 0
